// removed by extract-text-webpack-plugin
module.exports = {"base":"Subtitle_base--GUE67","clan":"Subtitle_clan--DDSxE"};


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Subtitle/Subtitle.scss
// module id = 541
// module chunks = 11 14